import { IMAGE_LOADED } from "../types/image/image";

const initialState = {
  "/staging/male/Age_1.png": false,
  "/staging/male/Age_2.png": false,
  "/staging/male/Age_3.png": false,
  "/staging/male/Age_4.png": false,
  "/staging/female/Age_1.png": false,
  "/staging/female/Age_2.png": false,
  "/staging/female/Age_3.png": false,
  "/staging/female/Age_4.png": false,
  "/staging/goal/male/1.png": false,
  "/staging/goal/male/2.png": false,
  "/staging/goal/male/3.png": false,
  "/staging/goal/male/4.png": false,
  "/staging/goal/female/1.png": false,
  "/staging/goal/female/2.png": false,
  "/staging/goal/female/3.png": false,
  "/staging/goal/female/4.png": false,
  "/community/Male.jpg": false,
  "/community/Female.jpg": false,
  "/income/1.png": false,
  "/income/2.png": false,
  "/income/PigiBank.jpg": false,
  "/levels/Low.png": false,
  "/levels/Middle.png": false,
  "/levels/High.png": false,
  "/imoji/Struggling.png": false,
  "/imoji/Head_with_tap.png": false,
  "/imoji/Confused.png": false,
  "/imoji/confort.png": false,
  "/imoji/Confused.png": false,
  "/imoji/thinking.png": false,
  "/imoji/swag.png": false,
  "/imoji/shoking.png": false,
  "/imoji/irritating.png": false,
  "/imoji/thumb_down_1.png": false,
  "/imoji/thumb_down_1.png": false,
  "/imoji/thumb_up_1.png": false,
  "/imoji/thumb_up_1.png": false,
  "/imoji/star_struk.png": false,
  "/male/lower_shadow_male.jpg": false,
  "/jobs/freelancer.png": false,
  "/jobs/linkedIn.png": false,
  "/jobs/fivver.png": false,
  "/jobs/guru.png": false,
  "/jobs/toptal.png": false,
  "/jobs/upwork.png": false,
  "/jobs/designhill.png": false,
  "/jobs/flexjobs.png": false,
  "/jobs/behance.png": false,
  "/jobs/wwr.png": false,
  "/workBalance/work-balance.jpg": false,
  "/workBalance/work-balance-female.jpg": false,
  "/workSituation/balance.png": false,
  "/workSituation/gear.png": false,
  "/wishes/house.png": false,
  "/wishes/ring.png": false,
  "/wishes/bag.png": false,
  "/wishes/car.png": false,
  "/wishes/juice_glass.png": false,
  "/loading/star.svg": false,
  "/payment/flex-low.svg": false,
  "/payment/flex-high.svg": false,
  "/payment/income-low.svg": false,
  "/payment/income-high.svg": false,
  "/payment/ng-arrows.svg": false,
  "/payment/apple-pay.svg": false,
  "/payment/green-tick.svg": false,
  "/payment/male.jpg": false,
  "/payment/female.jpg": false,
  "/payment/male-transform.png": false,
  "/payment/female-transform.png": false,
};

const imageLoadReducer = (state = initialState, action) => {
  switch (action.type) {
    case IMAGE_LOADED:
      return {
        ...state,
        [action.payload]: true,
      };
    default:
      return state;
  }
};

export default imageLoadReducer;
